import { useEffect, useState } from "react";
import { AxiosInstance } from "axios";
import { BullenStandingResponseStandingEntry } from "../models/api";
import { fetchStandings } from "./api";

export const useStandings = (api: AxiosInstance, leagueId: number) => {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [standings, setStandings] = useState<BullenStandingResponseStandingEntry[]>([]);

	useEffect(() => {
		let cancelled = false;
		fetchStandings(api, leagueId)
			.then((response) => {
				if (cancelled) return;
				setStandings(response.standings.results);
				setLoading(false);
			})
			.catch(() => {
				if (cancelled) return;
				setError("Failed to load standings. Please refresh.");
				setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [api, leagueId]);

	return { loading, error, standings };
};
